<template>
	<div>
		<div class="msgbox">
			<div class="msgboxTop">
				<div class="fh_button" @click="fanhui" style="cursor:pointer;">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<ul ref="msgListContainer" style="" class="msgboxul" :class="{'gaodu': status==5 || status==0 || status==-1 || status==-2}">
				<li v-for="(i,index) in msglist" :key="i.date_label || index" style="overflow:hidden;">
					<div style="width:100%;line-height:50rpx;text-align:center;font-size:24rpx;color:#666;">
						———{{i.date_label}}———
					</div>
					<div v-for="(g,msgIndex) in i.messages" :key="msgIndex" :id="(index === msglist.length - 1 && msgIndex === i.messages.length - 1) ? 'lastMessage' : ''">
						<div v-if="g.type=='1'" class="typeleft">
							<img :src="g.user.avatar" alt="" srcset="" />
							<div>
								<p>{{g.user.nickname}}</p>
								<span>{{g.content}}</span>
								<p  style="font-size:12px;color:#999;margin-top:5px;">{{g.create_time}}</p>
							</div>
						</div>
						<div v-if="g.type=='2'" class="typeright">
							<div style="margin-right:10px;display: flex;flex-wrap: wrap;justify-content: end;">
								<p>{{g.user.nickname}}</p>
								<span>{{g.content}}</span>
								<p  style="font-size:12px;color:#999;margin-top:5px;">{{g.create_time}}</p>
							</div>
							<img  :src="g.user.avatar" alt="" srcset="" />
						</div>
					</div>
				</li>
			</ul>
			<div class="msgboxsr" v-if="status!=5 && status!=0 && status!=-1 && status!=-2">
				<textarea  v-model="soso"  placeholder="在此处输入..." ></textarea>
				<div style="display:flex;justify-content: end;margin-top:5px;">
					 <el-button type="primary" icon="el-icon-position" size="small" @click="fasong">发送</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {OrderMessagelist,OrderMessageAdd} from "@/api/api.js"
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
			page:1,
			msglist:[],
			soso:"",
			bottomval:"0",
			jianjie:true,
			// status:"",
			scrollTimer: null // 用于存储滚动定时器
	    }
	  },
	  computed: {
		o_id() {
		   return this.$route.query.oid || ''
		},
		status() {
		   return this.$route.query.status || ''
		}
	  },
	  mounted() {
	      this.getOrderMessagelist()
	  },
	  methods: {
		fanhui(){
		  	this.$router.go(-1)  
		},
		// 清除滚动定时器
		clearScrollTimer() {
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer)
				this.scrollTimer = null
			}
		},
		// 滚动到最后一条消息
		scrollToLastMessage() {
			// 清除之前的定时器
			this.clearScrollTimer()
			// 使用 nextTick 确保 DOM 更新完成
			this.$nextTick(() => {
				const container = this.$refs.msgListContainer
				if (!container) return
				// 延迟一点，等待图片等内容渲染完成后再滚动
				this.scrollTimer = setTimeout(() => {
					const items = container.querySelectorAll('li')
					const lastItem = items.length ? items[items.length - 1] : null
					if (lastItem && lastItem.scrollIntoView) {
						lastItem.scrollIntoView({ behavior: 'smooth', block: 'end' })
					}
					container.scrollTop = container.scrollHeight
					this.scrollTimer = null
				}, 100)
			})
		},
		getOrderMessagelist(){
			OrderMessagelist(this.o_id,{
				page:this.page,
				limit:50,
			}).then(res=>{
				 let msglist=[]
				if(this.page==1){
					msglist=res.data.data.data.reverse()
					msglist.forEach(item=>{
						item.messages.reverse()
					})
					this.msglist=msglist
					// 数据加载完成后，滚动到最后一条消息
					this.scrollToLastMessage()
				}else{
					msglist=res.data.data.data.reverse()
					msglist.forEach(item=>{
						item.messages.reverse()
					})
					this.msglist=this.msglist.concat(msglist)
				}
				
			})
		},
		handleFocus(e){
			console.log(e.detail.height)
			this.jianjie=false
			this.bottomval=e.detail.height+"px"
			console.log(this.bottomval)
		},
		handleBlur(){
			this.jianjie=true
			this.bottomval="0"
		},
		fasong(){
			if(this.soso==''){
				this.$message.error('发送内容不能为空');
				return false
			}
			 OrderMessageAdd({
				 o_id:this.o_id,
				 content:this.soso
			 }).then(res=>{
				 console.log(res.data)
				 if(res.data.status==200){
					this.$message.success('留言成功');
					this.soso=""
					this.page=1
					this.getOrderMessagelist()
				 }else{
					 // this.$message.error(res.data.msg);
				 }
			 })
		}
	  },
	  beforeDestroy() {
	  	// 组件销毁前清除定时器
	  	this.clearScrollTimer()
	  },
	}
</script>

<style scoped>
	.gaodu{
		height:100vh !important;
	}
	.msgboxul{
		height:70vh;
		overflow: hidden;
		overflow-y:scroll;
		padding:60px 0px 20px;
		box-sizing: border-box;
	}
	.msgboxul::-webkit-scrollbar { /* Chrome, Safari, Opera*/
	  width:0px;
	  display: none;
	}
	.msgboxsr{
		width:1200px;
		height:20vh;
		background-color: #fff;
		position:fixed;
		padding:20px;
		box-sizing: border-box;
		bottom: 0;
		box-shadow: 0px -4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px 12px 12px 12px;
	}
	.msgboxsr textarea{
		width:100%;
		height:80px;
		border:none;
		background-color:#f6f6f6;
		resize: none;
		padding:10px;
		box-sizing: border-box;
	}
	.msgbox{
		width:1200px;
		margin:0 auto;
	}
	.typeleft{
		width:100%;
		display:flex;
		float: left;
		margin-bottom:10px;
	}
	.typeleft img{
		width:40px;
		height:40px;
		border-radius:50%;
		margin-right:10px;
	}
	.typeleft span{
		display:inline-block;
		max-width:1000px;
		padding:5px 10px;
		box-sizing: border-box;
		background: #fff;
		border-radius: 0px 8px 8px 8px;
		font-size: 14px;
		color: #333;
	}
	.typeleft p{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
	}
	.typeright{
		width:100%;
		float: right;
		display: flex;
		justify-content: end;
		margin-bottom:10px;
	}
	.typeright img{
		width:40px;
		height:40px;
		border-radius:50%;
		margin-right:10px;
	}
	.typeright span{
		display:inline-block;
		max-width:1000px;
		padding:5px 10px;
		box-sizing: border-box;
		background: #5984FF;
		border-radius: 8px 0px 8px 8px;
		text-align:left;
		font-size: 14px;
		color: #FFFFFF;
	}
	span{
		word-break: break-all;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
	.typeright p{
		width:100%;
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		text-align: right;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.msgboxTop{
		width:1200px;
		background-color:#EFF0F1 !important;
		position:fixed;
		top:80px;
		padding:20px 0px;
		border-radius:4px;
		box-sizing: border-box;
		display:flex;
		justify-content:end;
		align-items: center;
	}
	
</style>